const numOrFloatPatt = '^([1-9][0-9]*|0)([.]([0-9]+))?$';
const rule = {
    //园区
    park : {
        //基本信息
        partOne : {
            companyname: [{
                required: true,
                message: '请填写单位名称',
                trigger: 'blur'
            }],
            district_1st:[{
                required: true,
                message: '请选择省',
                trigger: 'change'
            }],
            district_2nd:[{
                required: true,
                message: '请选择市',
                trigger: 'change'
            }],
            district_3rd:[{
                required: true,
                message: '请选择区',
                trigger: 'change'
            }],
            address: [{
                required: true,
                message: '请填写地址',
                trigger: 'blur'
            }],
            xy: [{
                required: true,
                message: '请选择地图标注',
                trigger: 'change'
            }],
            park_class: [{
                required: true,
                message: '请选择园区类型',
                trigger: 'change'
            }],
            park_land_price:[{
                required: false,
                pattern: numOrFloatPatt,
                message: '请填写正确的土地价格',
                trigger: 'blur'
            }],
            park_invest_str: [{
                required: true,
                message: '请填写投资强度',
                trigger: 'blur'
            },{
                pattern: numOrFloatPatt,
                message: '请填写正确的投资强度',
                trigger: 'blur'
            }],
            park_tax_need: [{
                required: true,
                message: '请填写税收要求',
                trigger: 'blur'
            },{
                pattern: numOrFloatPatt,
                message: '请填写正确的税收要求',
                trigger: 'blur'
            }],
            park_base: [{
                required: true,
                message: '请填写基础设施',
                trigger: 'blur'
            }],
            intro: [{
                required: true,
                message: '请填写单位介绍',
                trigger: 'blur'
            }],
            material_upload_ids: [{
                required: true,
                type : "array",
                message: '请上传证明资料',
                trigger: 'change'
            }],
            mobile : [{
                required : false,
                pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
                message: '请填写正确的手机号',
                trigger: 'blur',
            }],
            phone :[{
                type: 'array',
                trigger: 'change'
            }],
        }
    },
    //政府
    grovment: {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: true,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: true,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: true,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: true,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: true,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写单位介绍',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        mobile : [{
            required : false,
            pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
            message: '请填写正确的手机号',
            trigger: 'blur',
        }],
        phone :[{
            type: 'array',
            trigger: 'change'
        }],
    },
    //职能部门
    department : {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: true,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: true,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: true,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: true,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: true,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写单位介绍',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        mobile : [{
            required : false,
            pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
            message: '请填写正确的手机号',
            trigger: 'blur',
        }],
        phone :[{
            type: 'array',
            trigger: 'change'
        }],
    },
    //商业项目
    business : {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: true,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: true,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: true,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: true,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: true,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写项目介绍',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        danwei_name: [{
            required: true,
            message: '请填写开发商名称',
            trigger: 'blur'
        }],
        mall_type: [{
            required: true,
            type : 'array',
            message: '请选择载体类型',
            trigger: 'change'
        }],
        mall_rent_type: [{
            required: true,
            type : 'array',
            message: '请选择租金模式',
            trigger: 'change'
        }],
        mall_area: [{
            required: true,
            message: '请填写建筑面积',
            trigger: 'blur'
        }],
        mall_commercial_area: [{
            required: true,
            message: '请填写商业面积',
            trigger: 'blur'
        }],
        mall_rent_price: [],
        mall_sell_price: [],
        mall_open_time: [{
            required: true,
            message: '请选择开业时间',
            trigger: 'change'
        }],
        mall_open_type: [{
            required: true,
            message: '请选择开业状态',
            trigger: 'blur'
        }],
        mall_need: [{
            required: true,
            type: 'array',
            message: '请添加招商需求',
            trigger: 'blur'
        }],
        mall_agency: [{
            required: true,
            message: '请填写代理机构',
            trigger: 'blur'
        }],
        mall_developer_intro: [{
            required: true,
            message: '请填写开发商简介',
            trigger: 'blur'
        }]
    },
    //写字楼项目
    building : {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: true,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: true,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: true,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: true,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: true,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写单位介绍',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        mobile : [{
            required : false,
            pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
            message: '请填写正确的手机号',
            trigger: 'blur',
        }],
        phone :[{
            type: 'array',
            trigger: 'change'
        }],
        office_rent_price : [],
        office_sell_price : [],
        office_property_fee : [{
            required: true,
            message: '请填写物业费用',
            trigger: 'blur'
        }],
        office_overground_floors : [{
            required: true,
            message: '请填写地上楼层',
            trigger: 'blur'
        }],
        office_underground_floors : [{
            required: true,
            message: '请填写地下楼层',
            trigger: 'blur'
        }],
        office_parks : [{
            required: true,
            message: '请填写停车位',
            trigger: 'blur'
        }],
        office_lift : [{
            required: true,
            message: '请填写电梯数',
            trigger: 'blur'
        }],
        office_single_area : [{
            required: true,
            message: '请填写单层面积',
            trigger: 'blur'
        }],
        office_free_period : [{
            required: true,
            message: '请填写免租期',
            trigger: 'blur'
        }]
    },
    //工业地产
    industry : {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: true,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: true,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: true,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: true,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: true,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写单位介绍',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        mobile : [{
            required : false,
            pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
            message: '请填写正确的手机号',
            trigger: 'blur',
        }],
        phone :[{
            type: 'array',
            trigger: 'change'
        }],
        industry_type_id :[],
    },
    //品牌商家
    brand : {
        companyname: [{
            required: true,
            message: '请填写单位名称',
            trigger: 'blur'
        }],
        district_1st:[{
            required: false,
            message: '请选择省',
            trigger: 'change'
        }],
        district_2nd:[{
            required: false,
            message: '请选择市',
            trigger: 'change'
        }],
        district_3rd:[{
            required: false,
            message: '请选择区',
            trigger: 'change'
        }],
        address: [{
            required: false,
            message: '请填写地址',
            trigger: 'blur'
        }],
        xy: [{
            required: false,
            message: '请选择地图标注',
            trigger: 'change'
        }],
        intro: [{
            required: true,
            message: '请填写品牌简介',
            trigger: 'blur'
        }],
        material_upload_ids: [{
            required: true,
            type : "array",
            message: '请上传证明资料',
            trigger: 'change'
        }],
        danwei_name: [{
            required: true,
            message: '请填写企业名称',
            trigger: 'blur'
        }],
        mall_price1: [],
        mall_price2: [],
        mall_scope: [{
            required: true,
            message: '请填写经营规模',
            trigger: 'blur'
        }],
        mall_area1: [],
        mall_area2: [],
        mall_rent1: [],
        mall_rent2: [],
        mall_business:[{
            required: true,
            type : 'array',
            message: '请选择经营形式',
            trigger: 'change'
        }],
        mall_firstchoose:[{
            required: true,
            type: 'array',
            message: '请选择首选物业',
            trigger: 'change'
        }],
        mall_add_require: [{
            required: true,
            message: '请填写选址要求',
            trigger: 'blur'
        }],
        mall_district: [],
    },
    //商业项目-联系人
    card : {
        sex : [{
            required: true,
            message: '请选择性别',
            trigger: 'blur'
        }],
        mobile: [{
            required : false,
            pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
            message: '请填写正确的手机号',
            trigger: 'blur',
        }],
        phone: [],
        email: [],
    },
};

export default rule;


// WEBPACK FOOTER //
// ./src/validateRule/company/editCompany.js